import React from 'react'

import { Container } from '@sainsburys-tech/fable'
import { AlertCircle } from '@sainsburys-tech/icons'

import PublicDSIBHeader from '../PublicDSIBHeader'

const TokenUsed = () => (
  <Container as="div" className="dsib-emailVerification">
    <PublicDSIBHeader />

    <main className="dsib-emailVerification__content">
      <section className="dsib-emailVerification__panel" aria-live="polite">
        <div className="dsib-emailVerification__statusRow" role="alert">
          <AlertCircle className="dsib-emailVerification__statusIcon" aria-hidden="true" focusable="false" />
          <div className="dsib-emailVerification__statusTitle">Your password has already been changed</div>
        </div>

        <p className="dsib-emailVerification__helpText">
          If you want to change your password again you must request this again via the Digital sign-in book app.
        </p>
      </section>
    </main>
  </Container>
)

export default TokenUsed
